import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { TodoListResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTodoListsReturn {
  lists: TodoListResponse[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

/**
 * Lists the Vault-resident todo lists for a Holder. Returns an empty
 * stable shape until a Holder is selected so the caller can render
 * without conditionals.
 */
export function useTodoLists(holderId: string | null): UseTodoListsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.todoLists.my(holderId ?? ''),
    queryFn: () => api.listTodoLists(holderId as string),
    enabled: !!holderId,
  });

  return {
    lists: data?.lists ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load todo lists' : null,
    refresh: () => {
      refetch();
    },
  };
}
